export enum CurrencyType {
  USD = 'USD',
  EUR = 'EUR',
}
